import React, { FC, memo } from 'react';

import { BaseLayout } from 'src/components/common/BaseLayout';
import { CommonSizes } from 'src/components/common/CommonSizes';
import { Footer } from 'src/components/Footer';
import { Header } from 'src/components/Header';
import { CommonOverlay } from 'src/components/overlays';
import { PlusSubscriptionModals } from 'src/components/plusSubscription/modals';
import { UiGlobalLoadingIndicator } from 'src/components/UI/GlobalLoadingIndicator';
import { UiFullScreenLoader } from 'src/components/UI/loaders/FullScreenTransparent';
import { AdministrationPages } from 'src/pages/Administration/administration';
import { RouteTitle } from 'src/routes';

type Props = {
  path: string | undefined;
  shouldUseBaseLayout: boolean;
};

export const AdministrationLayout: FC<Props> = memo(({ path, shouldUseBaseLayout }) => {
  const Component = (
    <>
      <Header />

      <CommonSizes />

      <UiGlobalLoadingIndicator hasRoutes>
        <RouteTitle path={path} />

        <React.Suspense fallback={<UiFullScreenLoader transparent />}>
          <AdministrationPages />
        </React.Suspense>

        <CommonOverlay />
      </UiGlobalLoadingIndicator>

      <PlusSubscriptionModals />

      <Footer />
    </>
  );

  return shouldUseBaseLayout ? <BaseLayout>{Component}</BaseLayout> : Component;
});
